























import {Component, Vue} from 'vue-property-decorator';
import {traineesClient} from "@/api/clients.context";
import {TraineeProfileModel} from "@/domain/trainees/TraineeProfileModel";

@Component({})

export default class Sensitive extends Vue {

    private trainees: TraineeProfileModel[] | null = [];

    async mounted() {
        const result = await traineesClient.getMyTrainees();
        this.trainees = result;
    }
}
